import VehicleDocuments from "../document/VehicleDocuments";
import { Button, Descriptions, Dropdown, Input, Popconfirm, Select, Space, Tabs } from "antd";
import { Link, useNavigate, useParams, useRouteLoaderData, useSearchParams } from "react-router";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { date2locale } from "../common/common";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";
import TablePage from "../components/TablePage";
import Inspections from "../inspection/Inspections";
import { useEffect, useState } from "react";
import { filterOption } from "../common/common";

const setupColumns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 70,
    ellipsis: true,
    render: (id) => (
      <Link to={`setups/${id}`} onClick={(event) => event.stopPropagation()}>
        {id}
      </Link>
    ),
  },
  { title: "Modello", dataIndex: "model", key: "model", ellipsis: true },
  { title: "Categoria", dataIndex: ["type", "description"], key: "type", ellipsis: true },
  {
    title: "Data ultima ispezione o acquisto",
    dataIndex: "firstInspectionDate",
    key: "firstInspectionDate",
    ellipsis: true,
    render: (date) => date && date2locale(date),
  },
];

function VehicleSetups({ id, navigate }) {
  const [types, setTypes] = useState([]);

  useEffect(() => {
    api.setupType.list({ pageSize: 9999 }).then(({ data }) => setTypes(data));
  }, []);

  return (
    <TablePage
      key={id}
      columns={setupColumns}
      addPath="setups/new"
      searchQueryName="model"
      addInTable
      enableSelection={false}
      filterItems={[
        { name: "model", label: "Modello", formItem: { children: <Input allowClear /> } },
        {
          name: "type",
          label: "Categoria",
          readableValue: (value) =>
            types.find((type) => String(type.id) === value)?.description ?? value,
          formItem: {
            children: (
              <Select
                allowClear
                showSearch
                filterOption={filterOption}
                options={types.map((type) => ({ label: type.description, value: String(type.id) }))}
              />
            ),
          },
        },
      ]}
      actionsMenu={{
        items: (record) => [
          { key: "edit", icon: <EditOutlined />, label: "Modifica" },
          { key: "delete", icon: <DeleteOutlined />, label: "Elimina", danger: true },
        ],
        onClick: (key, record, refresh) => {
          if (key === "edit") navigate(`setups/${record.id}/edit`);
          if (key === "delete") api.vehicleSetup.delete(record.id).then(refresh);
        },
      }}
      fetchFunction={(params) => api.vehicleSetup.list({ ...params, vehicle: id })}
    />
  );
}

export default function () {
  const navigate = useNavigate();
  const data = useRouteLoaderData("vehicle");
  const { id } = useParams();

  const items = [
    { key: "plate", label: "Targa", children: data.plate },
    { key: "type", label: "Categoria", children: data.type?.name },
    { key: "description", label: "Descrizione", children: data.description },
    {
      key: "firstInspectionDate",
      label: "Data ultima ispezione o acquisto",
      children: data.firstInspectionDate && date2locale(data.firstInspectionDate),
    },
  ];
  const tabItems = [
    !!data.type.inspectionMonths && {
      key: "inspections",
      label: "Revisioni",
      children: <Inspections showTitle={false} key={id} type="VEHICLE" id={id} />,
    },
    {
      key: "setups",
      label: "Allestimenti",
      children: <VehicleSetups  key={id} id={id} navigate={navigate} />,
    },
    { key: "documents", label: "Documenti", children: <VehicleDocuments key={id} vehicleId={id} /> },
  ].filter((x) => !!x);
  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli veicolo"
        secondary={`ID: ${id}`}
        extra={
          <Space size={4}>
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    key: "deleteVehicle",
                    label: (
                      <Popconfirm
                        title="Conferma rimozione"
                        onConfirm={() => api.vehicle.delete(id).then(() => navigate(".."))}
                        description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                      >
                        Elimina
                      </Popconfirm>
                    ),
                    danger: true,
                    icon: <DeleteOutlined />,
                  },
                ].filter((x) => !!x),
              }}
            >
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Space>
        }
      />
      <Descriptions
        layout="vertical"
        title={
          <>
            Informazioni generali
            <Button type="link" icon={<EditOutlined />} onClick={() => navigate("edit")} />
          </>
        }
        column={3}
        colon={false}
        items={items}
      />
      <Tabs
        style={{marginTop: 48}}
        size={"large"}
        items={tabItems}
        destroyOnHidden
      />
    </div>
  );
}
